// Nature of Business (owner, 2026-10-10): chosen from South Africa's Standard Industrial Classification,
// 7th edition (Stats SA) - /data/sic7.json, made by scripts/prepare_sic7.py: [code, description, words].
// The words are what the manual says each activity includes, plus everyday words ("plumber",
// "dentist", "attorney"). Loaded the first time the field is used (about 66 KB compressed).

let loading = null;

export const loadNatures = () => {
  if (!loading) {
    loading = fetch("/data/sic7.json")
      .then((r) => {
        if (!r.ok) throw new Error("The list of businesses could not be loaded.");
        return r.json();
      })
      .then((rows) => rows.map(([code, text, words]) => ({
        code,
        text,
        low: text.toLowerCase(),
        all: `${text} ${words}`.toLowerCase(),
      })))
      .catch((err) => {
        loading = null; // try again next time
        throw err;
      });
  }
  return loading;
};

// "plumber" -> "plumb" (finds "Plumbing ..."), "dentists" -> "dent"; short words are kept as they are
const STEM = /(ians|ian|ists|ist|ers|er|ing|s)$/;
const stem = (w) => {
  if (w.length <= 4) return w;
  const s = w.replace(STEM, "");
  return s.length >= 4 ? s : w;
};

// The words of the search can appear anywhere (owner: not only at the start). Order: the exact words
// in the description, then the exact words among its search words ("electrician" -> Electrical
// installation), then the shortened words ("plumber" -> plumbing); when no activity has all the words,
// those with the most of them ("farm cattle" -> Raising of cattle ...)
export const searchNatures = (list, query, limit = 40) => {
  // A SIC code (owner, 2026-10-11: often known): "60100" -> Radio broadcasting; the start of one ("601",
  // "SIC 4322") lists the activities whose codes begin with it, in code order
  const code = query.trim().match(/^(?:sic\s*)?(\d{2,5})$/i);
  if (code) return list.filter((e) => e.code.startsWith(code[1])).slice(0, limit);
  const exact =query.toLowerCase().split(/[^a-z0-9&]+/).filter((w) => w.length >= 2);
  if (!exact.length) return [];
  const stems = exact.map(stem);
  const rank = (e) => {
    if (exact.every((w) => e.low.includes(w))) return 0;
    if (exact.every((w) => e.all.includes(w))) return 1;
    if (stems.every((w) => e.low.includes(w))) return 2;
    if (stems.every((w) => e.all.includes(w))) return 3;
    return null;
  };
  let hits = list.map((e) => [rank(e), e]).filter((h) => h[0] !== null);
  if (!hits.length && stems.length > 1) {
    // fewest missing words first; then the most of them in the description itself
    hits = list
      .map((e) => [(stems.length - stems.filter((w) => e.all.includes(w)).length) * 10
        - stems.filter((w) => e.low.includes(w)).length, e])
      .filter((h) => h[0] < stems.length * 10); // at least one of the words
  }
  hits.sort((a, b) => a[0] - b[0] || a[1].text.localeCompare(b[1].text));
  return hits.slice(0, limit).map((h) => h[1]);
};
